import { IPartnerAuthState } from './state';
import { IPartnerAuthAction } from './action';

export const defaultState: IPartnerAuthState = {
    isLogin: false,
    partnerIdx: 0,
    partnerUserIdx: 0,
    name: '',
    profileImage: '',
    partnerStatus: '',
    partnerUserDocStatus: '',
    partnerUserActiveStatus: '',
    service: [],
    isOwner: false,
    nopay: false,
    nocard: false,
    membershipActive: false,
    guide: false,
};

export interface IPartnerAuthReducer {
    // eslint-disable-next-line no-unused-vars
    (state: IPartnerAuthState, action: IPartnerAuthAction): IPartnerAuthState;
}

export default function partnerAuthReducer(state: IPartnerAuthState, action: IPartnerAuthAction) {
    switch (action.type) {
        case 'LOGIN': {
            return action.value || state;
        }
        case 'LOGOUT': {
            return defaultState;
        }
        default: {
            throw new Error(`unexpected action.type: ${action.type}`);
        }
    }
}
